module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"about":"Über","hide":"Ausblenden"},"en":{"about":"About","hide":"Hide"}}')
  delete Component.options._Ctor
}
